const review = [
    {
      customerId: '3214',
      review:
        "I had a complex research paper to complete, and your Writers delivered exceptional results. The writer demonstrated a deep understanding of the topic, conducted thorough research, and presented the information in a clear and concise manner. The paper was well-structured, properly formatted, and delivered ahead of the deadline. I highly recommend their services for academic writing needs.",
      rating: '4.8',
    },
    {
      customerId: '4563',
      review:
        "Thank you for saving me during a hectic semester. your  writer is highly knowledgeable and professional. I requested assistance with multiple essays, and they consistently provided high-quality work that earned me top grades. The customer support team was also prompt and helpful throughout the process. I'm grateful for his expertise and will continue using your services.",
      rating: '4.7',
    },
    {
      customerId: '6743',
      review:
        "I needed an essay on a challenging topic within a tight deadline, and they delivered a well-researched and thoughtfully written piece. The writer created my essay as per my instructions. Although the price was varu affordable than others, the quality of their work justified it. I recommend their services for urgent assignments.",
      rating: '4.9',
    },
    {
      customerId: '23547',
      review:
        "I had a positive experience with Essaygrad. Their writer was responsive and receptive to my requirements. They produced a well-structured and coherent essay that reflected a deep understanding of the subject matter. The final paper was delivered on time and included accurate referencing. Essaygrad offers a professional and reliable service that I would use again.",
      rating: '4.5',
    },
    {
      customerId: '6754',
      review:
        "I have used Essaygrad multiple times, and they never disappoint. Their writers are excellent and delivers great work. Each essay I received was well-researched, original, and tailored to my specific instructions. Essaygrad is my go-to essay writing service for consistent excellence.",
      rating: '4.2',
    },
    {
      customerId: '8765',
      review:
        "Amazing essay content. The writer was attentive to details and delivered it on time. I appreciate their professionalism and would recommend their service.",
      rating: '4.3',
    },
    {
      customerId: '4325',
      review:
        "Your writer saved me from a tight deadline. Your writer crafted a high-quality essay that met all my requirements. The communication was smooth, and I'm impressed with the level of expertise she exhibited.",
      rating: '4.7',
    },
    {
      customerId: '5632',
      review:
        "I am getting consistently exceptional essays. Your writers have subject knowledge and provide well-researched papers. I've used essaygrad service multiple times, excellent experience.",
      rating: '4.6',
    },
    {
      customerId: '4512',
      review:
        "Angolina helped me with a challenging essay topic. She showed great understanding and delivered a well-structured paper. Your service is reliable and reasonably priced.",
      rating: '4.2',
    },
    {
      customerId: '3498',
      review:
        "Essaygrad exceeded my expectations with their professionalism. The writer followed my guidelines meticulously and delivered a top-notch essay. I'm impressed with their dedication to quality work.",
      rating: '4.8',
    },
    {
      customerId: '4590',
      review:
        "Quick and reliable service. Got my essay done within hours! Having tried multiple essay writing services, Essaygrad stands out as the best. Their writers consistently deliver superior quality, while their prices remain competitive.",
      rating: '4.6',
    },
    {
      customerId: '5612',
      review:
        "Very Impressive! writing service. I got it before my deadline As a first-time user of Essaygrad, I had a good experience. They transformed my ideas into a well-crafted essay that exceeded my expectations.",
      rating: '4.7',
    },
    {
      customerId: '4570',
      review:
        "Professional and knowledgeable writers who deliver excellent work.",
      rating: '4.9',
    },
    {
      customerId: '3412',
      review:
        "Saved me from a tight deadline. Highly recommended! When faced with a complex essay topic, I turned to Essaygrad for assistance. Their writer not only understood the requirements but also provided a unique and insightful perspective.",
      rating: '4.3',
    },
    {
      customerId: '4552',
      review:
        "Their essays are well-researched and provide valuable insights. Essaygrad has been my go-to writing service throughout my college years, and their quality content is awesome. Thank You!",
      rating: '4.5',
    },
    {
      customerId: '6654',
      review:
        "Efficient and responsive customer support. Great experience! What impressed me the most about Essaygrad was their writer's in-depth knowledge of the subject matter. They demonstrated a deep understanding that added credibility to my essay.",
      rating: '4.6',
    },
    {
      customerId: '3345',
      review: "Exceptional quality at an affordable price.",
      rating: '4.9',
    },
    {
      customerId: '7866',
      review: "Thank God writers have expertise in my particular essay subject. Very detailed essay thanks.",
      rating: '4.7',
    },
    {
      customerId: '3455',
      review: "Always deliver on time without compromising quality.",
      rating: '4.8',
    },
    {
      customerId: '2133',
      review: "I discovered Essaygrad through recommendations from my classmates, and they lived up to the hype. Their reputation for excellence is well-deserved, and I'm glad I chose them.",
      rating: '4.7',
    },
    {
      customerId: '5644',
      review: "Helped me boost my grades with their exceptional essays. Before using Essaygrad, I struggled with organizing my thoughts in essays. Their writer not only delivered an exceptional paper but also taught me valuable techniques for future writing assignments.",
      rating: '4.8',
    },
    {
      customerId: '6757',
      review: "Highly satisfied with their plagiarism-free papers.",
      rating: '5',
    },
    {
      customerId: '8798',
      review: "The writer captured the essence of the topic perfectly.",
      rating: '4.3',
    },
    {
      customerId: '5656',
      review: "From their user-friendly website to their attentive customer support and impeccable writing, Essaygrad offers a complete package. Their dedication to customer satisfaction is evident at every step of the process.",
      rating: '4.2',
    },
    {
      customerId: '6723',
      review: "Their service is a lifesaver during exam season.",
      rating: '4.7',
    },
    {
      customerId: '4467',
      review: "They understand the requirements and deliver as promised.",
      rating: '4.6',
    },
    {
      customerId: '7877',
      review: "I appreciate their professionalism and dedication.",
      rating: '4.7',
    },
    {
      customerId: '3499',
      review: "Essaygrad provided the perfect solution to my essay-writing challenges. Their skilled writers took my ideas and transformed them into a well-structured and coherent piece.",
      rating: '4.6',
    },
    {
      customerId: '2309',
      review: "The depth of research and insightful analysis in their essays is truly commendable.",
      rating: '4.2',
    },
    {
      customerId: '4570',
      review: "A dependable and trustworthy essay writing service that consistently produces excellent assignments.",
      rating: '4.3',
    },
    {
      customerId: '6679',
      review: "I'm impressed by the level of professionalism displayed by their writers. They not only meet deadlines but also produce well-structured and engaging essays.",
      rating: '4.4',
    },
    {
      customerId: '5211',
      review: "Their dedication to providing original and authentic content is remarkable. I never have to worry about plagiarism when I choose their services.",
      rating: '4.6',
    },
    {
      customerId: '4439',
      review: "I like your writing style, grammar, and punctuation. Your essays are a pleasure to read, and I always receive positive feedback from my professors.",
      rating: '4.8',
    },
    {
      customerId: '9986',
      review: "One aspect I appreciate about Essaygrad is their commitment to originality. Their plagiarism-free guarantee ensures that I can trust their work without any worries.",
      rating: '4.7',
    },
  ];
  
  export default review;